import { ResourceLanguage } from 'i18next'

const translation = {
    common: {
        atjVehicleType_car: 'Auto',
        atjVehicleType_atv: 'Maastoajoneuvo',
        atjVehicleType_motorbike: 'Moottoripyörä',
        atjVehicleType_moped: 'Mopo',
        atjVehicleType_trailer: 'Perävaunu',
        atjVehicleType_tractor: 'Traktori/työkone',
        privacyPolicy: 'Tietosuojaseloste',
        termsOfUse: 'Käyttöehdot',
        registerDescription: 'Rekisteriseloste',
        save: 'Tallenna',
        yes: 'Kyllä',
        no: 'Ei',
        ok: 'Hyväksy',
        cancel: 'Peruuta',
        campaignCode: 'Kampanjakoodi',
        no_campaign_code: 'Ei kampanjakoodia',
        customer: 'Asiakas',
        accept: 'Hyväksy',
        price: 'Hinta',
        paymentType: 'Maksutapa',
        personReserving: 'Varaaja',
        vehicle: 'Ajoneuvo',
        station: 'Asema',
        service: 'Palvelu',
        time: 'Aika',
        time_of_day: 'kello',
        time_of_day_abbr: 'klo',
        fuel: 'Käyttövoima',
        fuel_diesel: 'Diesel',
        fuel_diesel_electricity: 'Diesel/Sähkö',
        fuel_electricity: 'Sähkö',
        fuel_gas: 'Kaasu',
        fuel_no_engine: 'Moottoriton ajoneuvo',
        fuel_petrol: 'Bensiini',
        fuel_petrol_electricity: 'Bensiini/Sähkö',
        fuel_unknown: '-',
        manual_vehicle_group_car: 'Henkilöauto',
        manual_vehicle_group_van: 'Pakettiauto',
        manual_vehicle_group_camper: 'Matkailuauto',
        manual_vehicle_group_truck_light: 'Kevyt kuorma-auto nestejarruilla',
        manual_vehicle_group_truck_max12t: 'Kuorma-auto max. 12 000 kg',
        manual_vehicle_group_truck_over12t: 'Kuorma-auto yli 12 000 kg',
        manual_vehicle_group_bus_max5t: 'Linja-auto max 5000 kg',
        manual_vehicle_group_bus_over5t: 'Linja-auto yli 5000kg',
        manual_vehicle_group_moped: 'Mopo',
        manual_vehicle_group_mopedcar: 'Mopoauto',
        manual_vehicle_group_atv: 'Mönkijä',
        manual_vehicle_group_trailer_max3500: 'Perävaunu max. 3500 kg',
        manual_vehicle_group_trailer_max10t: 'Perävaunu max. 10 000 kg',
        manual_vehicle_group_trailer_over10t: 'Perävaunu yli 10 000 kg',
        registrationDate: 'Käyttöönottopäivämäärä',
        reservation: 'Ajanvaraus',
        reservationInfo: 'Ajanvarauksen info',
        vehicleGroup: 'Ajoneuvoluokka',
        vehicleType: 'Ajoneuvolaji',
        postalAddress: 'Postiosoite',
        postalCode: 'Postinumero',
        postOffice: 'Postitoimipaikka',
        week: 'Viikko',
        choose: 'Valitse',
        submit: 'Lähetä',
        back: 'Edellinen',
        next: 'Seuraava',
        continue: 'Jatka',
        firstName: 'Etunimi',
        lastName: 'Sukunimi',
        email: 'Sähköposti',
        phone: 'Puhelinnumero',
        registrationNumber: 'Rekisterinumero',
        close: 'Sulje',
    },
    errors: {
        postOffice: 'Virheellinen postitoimipaikka',
        postalAddress: 'Virheellinen postiosoite',
        postalCode: 'Virheellinen postinumero',
        register: 'Virheellinen rekisterinumero',
        firstName: 'Virheellinen etunimi',
        lastName: 'Virheellinen sukunimi',
        email: 'Virheellinen sähköposti',
        phone: 'Virheellinen puhelinnumero',
        timeNotAvailable: 'Valitsemasi aika ei ole varattavissa',
        paymentFailed: 'Maksu epäonnistui.',
        cancelFailed: 'Varauksen peruminen epäonnistui. Ota yhteys asemalle.',
        required: 'Pakollinen tieto',
    },
    cancelledReservationContainer: {
        reservationCancelled: 'Varauksesi on peruttu.',
        cancelledParagraph: 'Varauksesi on peruttu onnistuneesti.',
        newReservation: 'Voit tehdä uuden varauksen täältä',
    },
    reservationDoneContainer: {
        thankYou: 'Kiitos varauksestasi!',
        thankYouParagraph: `Sinulle on lähetetty vahvistuksena linkki palvelukorttiin, jossa voit tarkastella varaustasi.`,
        serviceCardFromHere: 'Pääset palvelukortille myös tästä.',
        paymentFailed: 'Maksu epäonnistui!',
        paymentFailedParagraph: 'Varauksesi on kuitenkin onnistunut. Sinulle on lähetetty vahvistuksena linkki palvelukorttiin, jossa voit tarkastella varaustasi. Voit yrittää myös maksaa palvelun verkkomaksuna palvelukortin kautta.',
    },
    serviceCardContainer: {
        serviceCard: 'Palvelukortti',
        reportHelperText: 'Tästä pääset lataamaan katsastusraportin sekä kuitin.',
        feedbackSubmitOk: 'Kiitos palautteestasi!',
        createCalendarEvent: 'Luo kalenterimerkintä',
        feedbackText: 'Kirjallinen palaute',
        feedbackTitle: 'Anna palautetta',
        confirmParagraph: 'Peruuttamalla tilauksen hyväksyt peruutusehdot.',
        changeTimeTooltip: 'Ajan muuttaminen on mahdollista {{time}} ennen varauksen alkua',
        changeServiceTooltip: 'Palvelun muuttaminen on mahdollista {{time}} ennen varauksen alkua',
        checkInHelperText: 'Ilmoittautuminen aukeaa {{ time }} ennen varauksen alkua, jos maksu on suoritettu ennakkoon.',
        cancelHelperText: 'Varauksen peruminen on mahdollista {{ time }} ennen varauksen alkua. Mikäli olet jo maksanut varauksen, maksu hyvitetään automaattisesti.',
        paymentHelperText: 'Ennakkomaksu on mahdollista {{ time }} ennen varauksen alkua',
        paymentFailed: 'Maksu epäonnistui.',
        paymentInProgress: 'Maksun käsittely on kesken',
        dateSubmitOk: 'Vaihdettu aika katsastukseen: \n{{time}}',
        serviceSubmitOk: 'Vaihdettu palvelu: {{service}}',
        changeService: 'Muuta palvelua',
        changeTime: 'Muuta aikaa',
        clock: 'Kello',
        grade: 'Arvosana katsastus',
        gradeOffice: 'Arvosana toimisto',
        inspection: 'Katsastus',
        inspectReady: 'Katsastus on suoritettu.',
        refundInProgress: 'Maksupalautuksen käsittely on kesken',
        reservationDate: 'Varaamasi aika',
        reservationCancelled: 'Varauksesi on peruttu',
        checkedIn: 'Olet ilmoittautunut. Varauksesi alkaa {{time}}.',
        checkInFailed: 'Itsepalveluilmoittautuminen epäonnistui. Ilmoittaudu asemalla ennen katsastusta.',
        confirmCancelReservation: 'Haluatko peruuttaa varauksesi?',
        paymentFulfilled: 'Maksu suoritettu ({{price}} sis. alv {{vat}})',
        paymentRefunded: 'Maksu palautettu',
        prepaidPrice: 'Maksu verkossa',
        normalPrice: 'Maksu toimipisteessä',
        servicePrice: 'Palvelun hinta',
        confirmCheckIn: 'Haluatko ilmoittautua?',
        confirmCheckInContent: 'Tällä hyväksynnällä vahvistat ilmoittautumisen varattuun katsastukseen.',
        changeReservation: 'Muuta varausta',
        cancelReservation: 'Peru varaus',
        office: 'Toimipiste',
        checkIn: 'Ilmoittaudu',
        payNow: 'Maksa nyt',
        showDocuments: 'Näytä dokumentit',
        documents: 'Dokumentit',
        showOnMap: 'Näytä kartalla',
        downloadReceipt: 'Lataa kuitti',
        downloadCertificate: 'Lataa katsastustodistus',
        wantsResponse: 'Haluan vastauksen palautteeseen',
    },
    reminderSettings: {
        title: 'Tilaa katsastusmuistutus',
        submit: 'Lähetä',
    },
    rootContainer: {
        checkInfo: {
            heading: 'Tarkista puuttuvat/virheelliset tiedot',
            acceptTermsOfUse: 'Hyväksyn palvelun käyttöehdot',
            vehicleOwnership: 'Ajoneuvon omistaja/haltija',
        },
        inviteAddressInfo: 'Täytäthän myös osoitetiedot. Osoitetietojen avulla varmistamme, että katsastuskutsu lähetetään oikealle ajoneuvolle oikeaan aikaan. Kohdennuksessa käytetään apuna Traficomin liikenneasioiden rekisteriä.',
        onlineCheckOutInfo: 'Kun painat lopussa Varaa-nappia, sinut siirretään maksupalvelun sivulle',
        contactStation: 'Ota yhteys asemalle (puh. {{ phone }})',
        couldNotFindRegister: 'Rekisteritunnusta ei löytynyt!',
        iAccept: 'Hyväksyn palvelun ',
        inputCampaignCode: 'Syötä kampanjakoodi',
        showAll: 'Näytä kaikki',
        noAnswer: 'Ei vastausta',
        timeLeft: 'Varaus voimassa',
        showCheapest: 'Näytä edullisimmat',
        freeTimes: 'Vapaat ajat',
        noFreeTimes: 'Ei vapaita aikoja',
        specialOffer: 'Erikoistarjous',
        selected: 'Valittu',
        startingPrice: 'Alkaen',
        startingPrice_abbr: 'alk.',
        invoicePrice: 'Collector-lasku',
        prepaidPrice: 'Ennakkomaksajan etuhinta',
        reservable: 'Varattavissa',
        youAreReserving: 'Olet varaamassa',
        choosePaymentMethod: 'Valitse maksutapa',
        payNow: 'Maksa heti (Paytrail): {{price}}',
        payWithInvoice: 'Maksa laskulla: {{price}}',
        payAtStation: 'Maksa asemalla: {{price}}',
        nextInspectionBefore: 'Katsastettava viimeistään',
        nextAfterInspectionBefore: 'Jälkitarkastus viimeistään',
        ownerOrOccupant: 'Olen ajoneuvon',
        ownerOccupant: 'Omistaja / haltija',
        other: 'Joku muu',
        priceIncludesTraficomFee: 'Hintaan sisältyy Traficomin valvontamaksu {{price}}',
        allowOffers: 'Haluan lisäksi tietoa tarjouksista',
        allowSendingReminders: 'Haluan jatkossa muistutuksen, kun katsastus on ajankohtainen',
        viaTxt: 'Tekstiviestillä',
        viaEmail: 'Sähköpostilla',
        noStationsFound: 'Asemia ei löytynyt sijainnilla',
        inputRegistrationNumber: 'Syötä rekisterinumero',
        inputRegistrationInfo: 'Syötä ajoneuvon tiedot',
        chooseStation: 'Valitse asema',
        chooseService: 'Valitse palvelu',
        chooseDatetime: 'Valitse aika',
        fillInformation: 'Täytä tiedot',
        accept: 'Hyväksy',
        reserve: 'Varaa',
        vehicleInfo: 'Ajoneuvon tiedot',
        getRegisterInfo: 'Hae tiedot',
        appBarTitle: 'Katsastusasema Oy',
        registerNumber: 'Rekisterinumero',
        getStations: 'Hae asemat sijainnillani',
        registrationDate: 'Rekisteröity',
        manufacturer: 'Merkki',
        model: 'Malli',
        findDate: 'Etsi muu aika',
        cheapestPrices: 'Edullisimmat ajat',
        showMore: 'Näytä lisää',
        unregisteredVehicle: 'Rekisteröimätön ajoneuvo',
        vehicleNokConsumption: 'Lakimuutoksen ja muuttuneiden laitevaatimusten vuoksi emme juuri tällä hetkellä pysty katsastamaan autoanne.',
        vehicleNokMassM1: 'Valitettavasti emme pysty katsastamaan ajoneuvoanne.',
        cookieConsent: {
            title: 'Tämä sivusto käyttää evästeitä',
            disclaimer: 'Käytämme seuranta- ja tehokkuusevästeitä. Näiden evästeiden avulla kerätään tietoa sivustomme liikenteestä sekä käyttötavoista. Esim. nämä evästeet voivat seurata sitä, paljonko aikaa vietät sivustollamme, mikä auttaa meitä parantamaan sivustomme käyttökokemusta jatkossa. Näiden evästeiden avulla kerätty tietoa ei voida yhdistää yksittäiseen käyttäjään.',
            accept: 'Hyväksyn',
            refuse: 'Kieltäydyn',
        },
    },
    selfService: {
        title: 'Itsepalvelupiste',
        enterCustomerToken: 'Anna asiakastunnus',
        customerToken: 'Asiakastunnus',
        customerTokenNotFound: 'Tuntematon asiakastunnus',
        companyCustomer: 'Yritysasiakas',
        fetchingVehicleInformation: 'Haetaan ajoneuvon tietoja',
        vehicleInformationNotFound: 'Ajoneuvon tietoja ei löytynyt',
        vehicleInformationNotFoundInfo: 'Tarkista rekisteritunnuksen oikeinkirjoitus. Voit kysyä lisätietoja kassalta.',
        vehicleFound: 'Ajoneuvo:',
        selectService: 'Valitse palvelu',
        payWithCard: 'Korttimaksu',
        payOnline: 'Verkkomaksu',
        paymentAbortRequested: 'Keskeytetään maksutapahtuma',
        waitingForPaymentTerminal: 'Odotetaan maksupäätettä',
        followPaymentTerminalInstructions: 'Seuraa maksupäätteen ohjeita',
        selectTime: 'Valitse aika',
        selectDriveInHelpText: 'Jos olet varannut ajan tai haluat tulla drive-in katsastukseen',
        selectCheckInHelpText: 'Jos olet varannut ajan',
        selectDriveIn: 'Ilmoittaudu katsastukseen',
        selectOtherTimeHelpText: 'Jos haluat varata ajan muuhun ajankohtaan',
        selectOtherTime: 'Varaa katsastusaika',
        newReservation: 'Uusi ajanvaraus:',
        reserve: 'Varaa',
        reserveAndPay: 'Varaa ja maksa',
        reservationFound: 'Löytyi ajanvaraus:',
        reservationNotFound: 'Rekisteritunnuksella ei löydy ajanvarausta',
        signUp: 'Ilmoittaudu',
        payed: 'Maksettu',
        paymentOngoing: 'Maksu kesken',
        paymentViaInvoice: 'Laskulle',
        priceFrom: 'Alkaen',
        notPayed: 'Ei maksettu',
        reservationSucceeded: 'Varaus onnistui.',
        youHaveReservation: 'Sinulle on varattu aika',
        thankYou: 'Kiitos asioinnistasi!',
        enterRegistrationNumber: 'Syötä rekisteritunnus',
        enterRegistrationNumberInfo: 'Voit syöttää rekisteritunnuksen ilman väliviivaa',
        privacyPolicy: 'Käyttöehdot',
        inWorkQueue: 'on nyt työjonossa.',
        notInWorkQueue: 'Ajoneuvon vienti työjonoon epäonnistui',
        waitForService: 'Voit siirtyä odottelemaan, että autosi otetaan työn alle.',
        orderInspectionReminder: 'Tilaa ilmainen katsastusmuistutus täyttämällä alla olevat kentät',
        askUserInformation: 'Anna vielä omat yhteystietosi',
        selectInspection: 'Määräaikaiskatsastus',
        selectInspection2: 'Jälkitarkastus',
        selectOtherServices: 'Muut palvelut',
        selectOrderReminder: 'Tilaa katsastusmuistutus',
        noThankYou: 'Ei kiitos',
        doYouWantToOrderInspectionReminder: 'Haluatko tilata ilmaisen katsastusmuistutuksen?',
        doYouWantToOrderInspectionReminderInfo: 'Muistutus lähettää sinulle viestin, kun seuraava katsastusaika lähestyy.',
        screenReturns: 'Näyttö palautuu asiointinäkymään',
        inSeconds: 'sekunnin kuluttua',
        paymentSucceeded: 'Maksu onnistui',
        terminalNotConnected: 'Ei yhteyttä maksupäätteeseen',
        connect: 'Yhdistä',
        pay: 'Maksa',
        confirmEmail: 'Vahvista sähköposti',
        otherServicesClosed: 'Rekisteröintipalvelu on suljettu!',
        chooseService: 'Valitse palvelu',
        noServicesNotice: 'Ilmoittautuminen tai ajanvaraus itsepalvelupisteellä ei ole mahdollista tälle ajoneuvolle. Voit kysyä lisätietoja kassalta.',
        registrationServices: 'Rekisteröintipalvelut',
        initialRegistration: 'Ensirekisteröinti',
        changeOfOwner: 'Omistajan/haltijan vaihdos, luovutusilmoitus',
        trafficUseRegistration: 'Liikennekäyttöönotto ja liikennekäytöstä poisto',
        usageInformationChange: 'Käyttötiedon muutos (yksityinen, luvanvarainen…)',
        transferPermits: 'Siirtoluvat',
        licensePlateOrders: 'Kilpitilaukset',
        vehicleInsurance: 'Ajoneuvojen vakuutukset',
        modificationInspection: 'Muutoskatsastus',
        registrationInspection: 'Rekisteröintikatsastus',
        yourQueueNumberIs: 'Vuoronumerosi on',
        pleaseWaitForYourTurn: 'Voit siirtyä odottamaan, että asiakaspalvelija kutsuu vuoronumerolla.',
        registrationCustomersAreServedByQueueNumber: 'Rekisteröinnin asiakkaat palvellaan vuoronumerolla',
        specialInspectionCustomersAreServedByQueueNumber: 'Erikoiskatsastuksen asiakkaat palvellaan vuoronumerolla',
        takeQueueNumber: 'Ota vuoronumero',
        pleaseHaveRegistrationAndIdReady: 'Otathan rekisteritunnuksen ja henkilöllisyystodistuksen valmiiksi esiin.',
        prefillTransferForm: 'Jos asiointi koskee siirtolupaa voit halutessasi esitäyttää lomakkeen.',
        doYouWantToAbort: 'Haluatko varmasti keskeyttää?',
        abortHelpText: 'Haluatko keskeyttää tapahtuman ja palata aloitusnäkymään?',
        paymentEvent: 'Maksutapahtuma',
        scanQRCode: 'Skannaa QR-koodi puhelimella siirtyäksesi verkkomaksuun',
        giveEmailForOnlinePayment: 'Syötä Paytrail-verkkomaksuun liitettävä sähköpostiosoite',
        emailForOnlinePayment: 'Paytrail-verkkomaksuun liitetty sähköpostiosoite',
        onlinePaymentFailed: 'Paytrail-verkkomaksu epäonnistui. Voit yrittää maksamista uudelleen.',
        onlinePaymentChangeEmailInfo: 'Lue QR-koodi uudestaan sähköpostiosoitteen vaihtamisen jälkeen. Keskeytä mahdollisesti meneillään oleva maksu.',
        confirm: 'Vahvista',
        change: 'Vaihda',
        notice: 'Huomio!',
        noticeUnpaid: 'Järjestelmän mukaan ajoneuvolla on erääntyneitä maksuja. Katsastus voidaan suorittaa ja ajoneuvo tarkistaa, mutta katsastuspäätöstä ei voida tehdä.',
        noticeUnpaidHelp: 'Saat tarkemmat tiedot verkossa kirjautumalla Traficomin Oma asiointi -palveluun osoitteessa traficom.fi',
        close: 'Sulje',
        returnToStartScreen: 'Palaa aloitusnäkymään',
        returnToStart: 'Palaa alkuun',
        acceptTermsOfService: 'Hyväksy käyttöehdot',
        youHaveInspectionReminder: 'Katsastusmuistutuksen tilaus onnistui.',
        noticeNotAllowed: 'Ajoneuvolla on Traficomin järjestelmän mukaan rajoitteita. Useimmiten tämä johtuu erääntyneestä ajoneuvoverosta tai liikennevakuutusmaksusta. Rajoitustiedon vuoksi ilmoittautuminen itsepalvelupisteellä ei ole mahdollista. Voit kysyä lisätietoja kassalta.',
        checkoutNotification: 'Suorita ilmoittautuminen kassalla',
        futureReservationNotice: 'Huomasithan, että varauksesi ei ole tälle päivälle. Voit silti halutessasi ilmoittautua jonoon drive-in katsastukseen.',
        futureReservationNoticeNoDriveIn: 'Ajanvarauksesi ei ole tälle päivälle, eikä ilmoittautuminen ole vielä mahdollista.',
        otherReservationNotice: 'Huomasithan, että sinulla on jo ajanvaraus. Voit silti halutessasi varata uuden ajan.',
        registrationSuccessMessage: 'Ilmoittautuminen onnistui.',
        notInWorkQueueInfo: 'Ilmoittaudu kassalla',
        goingToWorkQueue: 'Ajoneuvoa viedään työjonoon',
        vehicleNokMassM1: 'Valitettavasti emme pysty katsastamaan ajoneuvoanne.',
        vehicleNoticeGoToDesk: 'Ilmoittautuminen tai ajanvaraus itsepalvelupisteellä ei ole mahdollista tälle ajoneuvolle. Voit kysyä lisätietoja kassalta.',
        reservationFailed: 'Valitettavasti drive-in-katsastukseen ei ole enää vapaita aikoja.',
        printing: 'Tulostus käynnissä',
        printError: 'Tulostus epäonnistui',
        checkInErrors: {
            notPaid: 'Ilmoittautuminen ei onnistu, koska maksua ei ole suoritettu.',
            reservationRemoved: 'Varaus on peruttu tai poistettu.',
            atjSearchFailed: 'Ajoneuvon tietojen haku epäonnistui.',
        },
    }
}

const _export: ResourceLanguage = { translation }

export default _export
